import React from 'react'
import StandardModal from './StandardModal'
import Search from '@/Search'

import { StyledSearchModalContainer } from './styles'

const SearchModal = ({
  isOpen,
  modalHandler
}) => {
  return (
    <StandardModal
      wrapperId='search-modal'
      isOpen={isOpen}
      setIsOpen={modalHandler}
      hideCloseButton
      wrapperProps={{
        css: {
          zIndex: 12,
          backdropFilter: 'blur(10px)',
        },
        exit: {
          opacity: 0,
          transition: { duration: 0.6 }
        },
      }}
      containerProps={{
        css: {
          backgroundColor: '$primary',
          with: '100%',
          display: 'block',
          transformOrigin: 'center left',
        },
        initial: { y: '-100%', },
        animate: { y: '0%', },
        exit: {
          y: '-100%', transition: { delay: 0.6 }
        },
        transition: {
          type: 'spring',
          duration: 0.4,
          mass: 0.1
        },
      }}
    >
      <StyledSearchModalContainer>
        <Search isOpen={isOpen} onClick={modalHandler} />
      </StyledSearchModalContainer>
    </StandardModal>
  )
}

export default SearchModal
